/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ranks.vue?vue&type=template&id=6762c57a&scoped=true"
import script from "./ranks.vue?vue&type=script&lang=js"
export * from "./ranks.vue?vue&type=script&lang=js"
import style0 from "./ranks.vue?vue&type=style&index=0&id=6762c57a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6762c57a",
  null
  
)

export default component.exports